export const TRIAL_DAYS = 3;
export const TRIAL_CREDITS = 500;
